// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../images/nav-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student_register {
  background-color: #2d3e97;
}
.student_register .student_block {
  position: relative;
}
.student_register .student_block::before {
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat top right;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
@media (max-width: 992px) {
  .student_register .student_block::before {
    background-size: 280%;
  }
}
.student_register .student_block .student-login-register {
  position: relative;
}
@media (max-width: 992px) {
  .student_register .student_block .student-login-register .navbar-collapse.show {
    background: #232f73 !important;
  }
}
.student_register .student_block .student-login-register .top-navbar {
  padding: 0.45rem 1rem;
}
.student_register .student_block .student-login-register .top-navbar a {
  color: #ffffff;
  text-decoration: none;
  font-family: "Titillium Web", sans-serif;
}
@media (min-width: 1200px) {
  .student_register .student_block .student-login-register .top-navbar a {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
}
.student_register .student_block .student-login-register .top-navbar a:last-child {
  border-right: 0;
}
.student_register .student_block .student-login-register .top-navbar a.active {
  color: #fff;
}
.student_register .student_block .title-sections {
  margin-top: 3rem;
  margin-bottom: 6rem;
}
.student_register .student_block .LayerCurve {
  display: none;
}
.student_register .student_footer {
  position: relative;
  background: #333333;
}
@media (max-width: 767px) {
  .student_register .student_footer {
    text-align: center;
  }
}
.student_register .student_footer .footer-top {
  background: #393939;
}
.student_register .student_footer .footer-top .import-link li {
  margin-right: 2rem;
}
.student_register .student_footer .footer-top .import-link li:last-child {
  margin-right: 0;
}
.student_register .student_footer .footer-top .social-list li {
  margin-right: 1rem;
}
.student_register .student_footer .footer-top .social-list li:last-child {
  margin-right: 0;
}
.student_register .student_footer .footer-middle .import-link2 li {
  margin-right: 3rem;
}
.student_register .student_footer .footer-middle .import-link2 li:last-child {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/login_register/_studentregister.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACQ;EACI,WAAA;EACA,uEAAA;EACA,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AACZ;AACY;EAVJ;IAWQ,qBAAA;EAEd;AACF;AACQ;EACI,kBAAA;AACZ;AACY;EACI;IACI,8BAAA;EAClB;AACF;AAEY;EACI,qBAAA;AAAhB;AAEgB;EACI,cAAA;EACA,qBAAA;EACA,wCAAA;AAApB;AAEoB;EALJ;IAMQ,6BAAA;IACA,8BAAA;EACtB;AACF;AACoB;EACI,eAAA;AACxB;AAEoB;EACI,WAAA;AAAxB;AAMQ;EACI,gBAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,aAAA;AALZ;AASI;EACI,kBAAA;EACA,mBAAA;AAPR;AASQ;EAJJ;IAKQ,kBAAA;EANV;AACF;AAQQ;EACI,mBAAA;AANZ;AAQY;EACI,kBAAA;AANhB;AAQgB;EACI,eAAA;AANpB;AAUY;EACI,kBAAA;AARhB;AAUgB;EACI,eAAA;AARpB;AAcY;EACI,kBAAA;AAZhB;AAcgB;EACI,eAAA;AAZpB","sourcesContent":[".student_register {\n    background-color: #2d3e97;\n\n    .student_block {\n        position: relative;\n\n        &::before {\n            content: \"\";\n            background: url(\"../../../images/nav-bg.png\") no-repeat top right;\n            background-size: cover;\n            position: absolute;\n            left: 0;\n            top: 0;\n            width: 100%;\n            height: 100%;\n\n            @media (max-width: 992px) {\n                background-size: 280%;\n            }\n        }\n\n        .student-login-register {\n            position: relative;\n\n            @media (max-width: 992px) {\n                .navbar-collapse.show {\n                    background: #232f73 !important;\n                }\n            }\n\n            .top-navbar {\n                padding: 0.45rem 1rem;\n\n                a {\n                    color: #ffffff;\n                    text-decoration: none;\n                    font-family: \"Titillium Web\", sans-serif;\n\n                    @media (min-width: 1200px) {\n                        padding-left: 20px !important;\n                        padding-right: 20px !important;\n                    }\n\n                    &:last-child {\n                        border-right: 0;\n                    }\n\n                    &.active {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        .title-sections {\n            margin-top: 3rem;\n            margin-bottom: 6rem;\n        }\n\n        .LayerCurve {\n            display: none;\n        }\n    }\n\n    .student_footer {\n        position: relative;\n        background: #333333;\n\n        @media (max-width: 767px) {\n            text-align: center;\n        }\n\n        .footer-top {\n            background: #393939;\n\n            .import-link li {\n                margin-right: 2rem;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n\n            .social-list li {\n                margin-right: 1rem;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n\n        .footer-middle {\n            .import-link2 li {\n                margin-right: 3rem;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
